import { Fab, Tooltip } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { Grid } from "@mui/material";
import DateRangePicker from "components/date-picker/DateRangePicker";
import MonthPicker from "components/date-picker/MonthPicker";
import Select from "components/select/Select";
import { useListPbxTypeAndBusiness } from "hooks/business-management/useListPbxTypeAndBusiness";
import { useEffect } from "react";
import { useGetListBusinessReportType } from "service/query/business-management.query";
import { getDateRangePickerFieldProps, getSelectFieldProps } from "ultis/form";

const BusinessReportsFilter = ({ formik }) => {
  const { listBusiness, listPbxType } = useListPbxTypeAndBusiness(
    formik.values.pbxType
  );

  const { data: listBusinessReportType } = useGetListBusinessReportType(
    {
      businessCode: formik.values?.businessCode,
    },
    { enabled: !!formik.values?.businessCode }
  );

  const scheduleType = formik.values.scheduleType;

  useEffect(() => {
    formik.setFieldValue("type", "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.businessCode]);

  useEffect(() => {
    formik.setFieldValue("businessCode", "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.pbxType]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Select
            {...getSelectFieldProps(formik, "pbxType")}
            label="Loại tổng đài"
            showAllOption
            options={listPbxType?.map((item) => ({
              label: item.name,
              value: item.pbxType,
            }))}
          />
        </Grid>
        <Grid item xs={4}>
          <Select
            {...getSelectFieldProps(formik, "businessCode")}
            label="Nghiệp vụ"
            options={listBusiness?.map((item) => ({
              label: item.name,
              value: item.businessCode,
            }))}
          />
        </Grid>
        <Grid item xs={4}>
          <Select
            {...getSelectFieldProps(formik, "type")}
            label="Loại báo cáo"
            options={listBusinessReportType?.map((item) => ({
              label: item.name,
              value: item.type,
            }))}
          />
        </Grid>

        <Grid item xs={3}>
          <Select
            {...getSelectFieldProps(formik, "scheduleType")}
            label="Loại thời gian"
            options={[
              {
                label: "Theo ngày",
                value: "daily",
              },
              {
                label: "Theo tháng",
                value: "monthly",
              },
            ]}
          />
        </Grid>

        {scheduleType === "daily" && (
          <Grid item xs={4.5}>
            <DateRangePicker
              {...getDateRangePickerFieldProps(formik, "dateRange")}
              startDateLabel="Từ ngày"
              endDateLabel="Đến ngày"
            />
          </Grid>
        )}

        {scheduleType === "monthly" && (
          <Grid item xs={3}>
            <MonthPicker {...getDateRangePickerFieldProps(formik, "month")} />
          </Grid>
        )}

        <Grid item xs={1.5}>
          <Tooltip title="Tìm kiếm" disableFocusListener>
            <Fab color="primary" aria-label="Search" type="submit">
              <Search />
            </Fab>
          </Tooltip>
        </Grid>
      </Grid>
    </form>
  );
};

export default BusinessReportsFilter;
